module.exports = __webpack_public_path__ + "static/media/ppe_haz_lev.26285990.png";